<div class="wrapper">
  <div class="header">
    <div class="headerLeft drop-padding">
      <h2 *ngIf="type !== 'selector'">
        {{
          searchControl.value
            ? 'Поиск : "' + searchControl.value + '" ' + this.resultLength + ' поз.'
            : 'Справочник товаров ' + this.resultLength + ' поз.'
        }}
      </h2>
      <form *ngIf="type === 'selector'" (ngSubmit)="setNewSearchValue()">
        <mat-form-field>
          <mat-label>Поиск</mat-label>
          <input matInput type="text" placeholder="Поиск" [formControl]="_searchControl" />
          <button mat-icon-button type="submit" matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </div>
    <div class="actionMenu">
      <button type="button" (click)="create()" mat-mini-fab color="primary">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" (click)="search()" mat-mini-fab color="primary">
        <mat-icon>refresh</mat-icon>
      </button>
      <button type="button" (click)="clear()" mat-mini-fab color="primary">
        <mat-icon>clear</mat-icon>
      </button>
      <button type="button" mat-mini-fab color="primary" (click)="leftBar.toggle()">
        <mat-icon>folder</mat-icon>
      </button>
      <button type="button" mat-mini-fab color="primary" (click)="rightBar.toggle()">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>
  <mat-drawer-container class="body" autosize>
    <mat-drawer [opened]="folderOpen" #leftBar class="leftBar" [mode]="drawerMode" position="start">
      <app-folder-list
        (clearEvent)="handleClearFolder()"
        (toggleEvent)="selectFolder($event)"
      ></app-folder-list>
    </mat-drawer>
    <mat-drawer [opened]="filterOpen" #rightBar class="rightBar" [mode]="drawerMode" position="end">
      <div class="leftBarWrapper">
        <app-catalogue-brand-selector
          [selectedBrands]="selectedBrands"
          (selectedBrandsChanges)="onBrandSelect($event)"
          [brands]="available_brands"
          [loading]="brandListLoading"
        ></app-catalogue-brand-selector>
        <app-new-property-selector
          [selectedProps]="selectedProperties"
          [availableProps]="availableProps"
          (propsSelectedEvent)="onPropsSelect($event)"
          [loading]="propsListLoading"
        ></app-new-property-selector>
      </div>
    </mat-drawer>
    <div class="mainContent">
      <div
        *ngIf="type !== 'selector' && (deviceType === 'DESKTOP' || deviceType === 'LAPTOP')"
        class="tableHeader"
      >
        <mat-checkbox (change)="search()" [formControl]="onlyInStockControl"
          >Только в наличии</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withoutFolderControl"
          >Без папки</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withoutBarcodeControl"
          >Без штрих-кода</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withoutAddressControl"
          >Без адреса хранения</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withAddressDebtControl"
          >Адресный долг</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="onlyBufferStockControl"
          >Только буфер</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withoutPlacedStockControl"
          >Без размещения</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="multiCellOnlyControl"
          >Несколько полок</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withoutImageControl"
          >Без изображения</mat-checkbox
        >
        <mat-checkbox (change)="search()" [formControl]="withoutPropsControl"
          >Без характеристик</mat-checkbox
        >
      </div>
      <div
        #drawerContainer
        (scroll)="onScroll($event)"
        [ngClass]="{ productTableWrapperSelector: type === 'selector' }"
        class="productTableWrapper"
      >
        <app-product-table
          [loading]="loadingProducts"
          [products]="products"
          (sortEvent)="sortData($event)"
          [columnsToDisplay]="columnsToDisplay"
          [productsFormArray]="productsFormArray"
          [selectedProductsFormArray]="selectedProductsFormArray"
          [loadingProducts]="loadingProductsInTable"
          (removeEvent)="remove($event)"
        ></app-product-table>
        <app-product-analogue-list
          *ngIf="products.length === 1 && type !== 'selector'"
          [product]="products[0]"
        ></app-product-analogue-list>
      </div>
    </div>
  </mat-drawer-container>
</div>
